module.exports = __webpack_public_path__ + "static/img/12_old.ed12e54f.png";